import {useConfig} from "../../components/Context/ConfigContext";

const OwnerPage = () => {
  const steps = [
    "Create your account and manage multiple stores",
    "Add categories and products with accurate pricing",
    "Set your store location on map to reach nearby customers",
    "Receive customer orders instantly and accept or reject easily",
    "Prepare orders and manage pickup or delivery smoothly",
    "Collect payments at store (Cash / Online) and update status",
    "Track total revenue, orders, and pending payments from dashboard",
    "View date-wise daily collection and manage all transactions",
    "Complete orders and send automatic updates to customers",
  ];

  const features = [
    "Multi-Store Management – Handle multiple stores in one account",
    "Smart Dashboard – Track revenue, orders & pending payments",
    "Daily Collection Reports – Date-wise transaction tracking",
    "Easy Order Management – From order to completion flow",
    "Location-Based Reach – Get discovered by nearby customers",
  ];

    const {configData} = useConfig();
    return (
    <div className="min-h-screen bg-zinc-50 dark:bg-slate-950 px-4 py-8">
      <div className="max-w-5xl mx-auto space-y-10">
        {/* HEADER */}
        <div className="text-center space-y-3">
          <h1 className="text-3xl md:text-4xl font-black text-zinc-900 dark:text-white">
            🏪 Grow Your Store with Dukansetu
          </h1>
          <p className="text-sm md:text-base text-zinc-600 dark:text-slate-400 max-w-2xl mx-auto">
            Dukansetu helps store owners digitize their business operations by
            bringing everything onto a single platform. From managing multiple
            stores and organizing categories to adding products with accurate
            pricing, it simplifies day-to-day store management.
          </p>
        </div>

        {/* DESCRIPTION */}
        <div className="bg-white dark:bg-slate-900 rounded-3xl p-6 md:p-8 shadow-md border border-zinc-200 dark:border-slate-800">
          <p className="text-sm md:text-base text-zinc-600 dark:text-slate-300 leading-relaxed">
            Store owners can receive and manage customer orders in real-time,
            handle pickup and delivery efficiently, and update order status with
            ease. With a smart dashboard, they can track total revenue, monitor
            pending payments, and view date-wise daily collections for better
            financial control.
          </p>
          <p className="mt-4 text-sm md:text-base text-zinc-600 dark:text-slate-300 leading-relaxed">
            Overall, Dukansetu empowers store owners to streamline operations,
            improve customer experience, and grow their business with a simple,
            fast, and reliable digital solution.
          </p>
        </div>

        {/* HOW IT WORKS */}
        <div>
          <h2 className="text-xl font-black text-orange-500 mb-6">
            ⚙️ How it Works
          </h2>

          <div className="grid gap-4">
            {steps.map((step, i) => (
              <div
                key={i}
                className="bg-white dark:bg-slate-900 border border-zinc-200 dark:border-slate-800 rounded-2xl p-5 shadow-sm hover:shadow-md transition"
              >
                <div className="flex gap-4">
                  <div className="min-w-[36px] h-[36px] flex items-center justify-center rounded-xl bg-orange-500 text-white font-bold">
                    {i + 1}
                  </div>

                  <p className="text-sm text-zinc-600 dark:text-slate-300 font-medium">
                    {step}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* FEATURES */}
        <div>
          <h2 className="text-xl font-black text-green-600 mb-6">
            🚀 Key Features
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {features.map((feature, i) => (
              <div
                key={i}
                className="bg-white dark:bg-slate-900 border border-zinc-200 dark:border-slate-800 rounded-2xl p-5 text-sm font-semibold text-zinc-700 dark:text-slate-300 shadow-sm hover:shadow-md transition"
              >
                ✔ {feature}
              </div>
            ))}
          </div>
        </div>

        {/* WHY */}
        <div className="bg-gradient-to-r from-orange-500 to-pink-500 text-white rounded-3xl p-6 md:p-8 shadow-xl">
          <h2 className="text-xl font-black mb-3">Why Dukansetu?</h2>
          <p className="text-sm md:text-base opacity-90 leading-relaxed">
            Dukansetu empowers store owners with digital tools to simplify
            operations, increase visibility, and manage business efficiently in
            real-time.
          </p>
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-zinc-500 dark:text-slate-400">
            For any queries, contact us at{" "}
            <a
              href={`mailto:${configData?.support_email}`}
              className="text-orange-500 font-semibold hover:underline"
            >
                {configData?.support_email}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OwnerPage;
